import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { ColumnsType } from 'antd/lib/table';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Button, Card, DatePicker, Menu, Table } from 'antd';

import useDebounce from '@root/core/hooks/useDebounce';
import useTranslate from '@root/core/hooks/useTranslate';
import SearchBox from '@root/modules/Sellers/Inquiry/components/Search';
import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import DropdownButton from '@root/modules/Sellers/Inquiry/components/DropdownButton';

import buskStock from '../services/buskstock';
import { formatDateTime } from '@root/utils/helpers/formatDate';

interface DataType {
  key: React.Key;
  no: number;
  name: string;
  address: string;
  country: number;
  updated_at: Date;
  setSelectedRow: React.Dispatch<React.SetStateAction<React.Key[]>>;
}

const BuskStock = () => {
  const [t] = useTranslate();
  const [list, setList] = useState([] as any);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [listExcel, setListExcel] = useState([] as any);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItem, setTotalItem] = useState();
  const [loading, setLoading] = useState(false);
  const [save, setSave] = useState([] as any);
  const [currentPage, setCurrentPage] = useState(1);
  const [labelType, setLabelType] = useState({
    key: '2',
    label: t('seller:button:select')
  } as any);
  const [proName, setProName] = useState('');
  const [valueSearch, setValueSearch] = useState('');
  const debounc = useDebounce(valueSearch, 1000);
  const [sort, setSort] = useState(true);
  const history = useHistory();

  const [dateValue, setDateValue] = useState<[string, string]>();
  const fromDt: string = (dateValue && dateValue[0]) || '';
  const toDt: string = (dateValue && dateValue[1]) || '';

  const Breadcrumb = [
    {
      tittle: '재고 관리',
      url: ''
    },
    {
      tittle: '물류센터 조회',
      url: ''
    }
  ];

  const columns: ColumnsType<DataType> = [
    {
      title: 'No',
      dataIndex: 'no'
    },
    {
      title: t('table:seller:logistic-center'),
      dataIndex: 'name'
    },
    {
      title: t('table:seller:address'),
      dataIndex: 'address'
    },
    {
      title: '국가',
      dataIndex: 'country'
    },
    {
      title: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {t('table:seller:update')}
          {!!sort ? (
            <DownOutlined
              style={{ marginLeft: '15px' }}
              onClick={() => setSort(false)}
            />
          ) : (
            <UpOutlined
              style={{ marginLeft: '15px' }}
              onClick={() => setSort(true)}
            />
          )}
        </div>
      ),
      dataIndex: 'updated_at'
    }
  ];

  const getProductName = (e: any) => {
    setProName(e.key);
    setLabelType({ key: e.key, label: e.domEvent.target.innerText });
  };
  const onChangeState = (name: string, value: string) => {
    setValueSearch(() => {
      return value;
    });
  };
  const getDate = (value: [string, string]) => {
    setDateValue(value);
  };

  const listLabel = [
    {
      id: 1,
      labelTitle: t('seller:button:select'),
      listMenu: (
        <Menu
          onClick={getProductName}
          items={[
            {
              label: t('seller:button:select'),
              key: ''
            },
            {
              type: 'divider'
            },
            {
              label: '물류센터명',
              key: 'name'
            },
            {
              type: 'divider'
            },
            {
              label: '주소',
              key: 'detailAddress'
            },
            {
              type: 'divider'
            },
            {
              label: '국가',
              key: 'countryName'
            }
          ]}
        />
      )
    }
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeyss: React.Key[], selectedRows: DataType[]) => {
      setListExcel(selectedRows);
      setSelectedRowKeys(selectedRowKeyss);
      if (
        save.length > 0 &&
        save.some((item: any) => item.page == currentPage)
      ) {
        let a = save.findIndex((item: any) => item.page == currentPage);
        save[a] = { page: currentPage, select: selectedRowKeyss };
      } else {
        setSave((item: any) => [
          ...item,
          ...[{ page: currentPage, select: selectedRowKeyss }]
        ]);
      }
    },
    getCheckboxProps: (record: DataType) => ({
      // disabled: record.productName === "Disabled User", // Column configuration not to be checked
      name: record.name
    })
  };

  const { RangePicker } = DatePicker;
  const dateFormat = 'YYYY/MM/DD';
  const idExport = save.reduce(
    (s: number[], x: any) => [...s, ...x.select],
    []
  );

  const handelExportExcel = async (
    fieldSearch: string,
    productName: string,
    sort: boolean,
    fromDt: string,
    toDt: string
  ) => {
    if (listExcel.length > 0) {
      let listId = save.reduce(
        (s: number[], x: any) => [...s, ...x.select],
        []
      );
      const responseById = await buskStock.exportWarehouseExcellById({
        fieldSearch,
        productName,
        sort,
        fromDt,
        toDt,
        listId
      });
      const outputFilename = `Warehouse${new Date().getTime()}.xlsx`;
      const url = URL.createObjectURL(new Blob([responseById]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    } else {
      const response = await buskStock.exportExcelWarehouse({
        fieldSearch,
        productName,
        sort,
        fromDt,
        toDt
      });
      const outputFilename = `Warehouse${new Date().getTime()}.xlsx`;
      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    }
  };

  const getPagination = async (
    page: number,
    fromDt: string,
    toDt: string,
    filter: string,
    input: string,
    sort: boolean
  ) => {
    setLoading(true);
    const temp = await buskStock.getListWarehouse(
      page,
      fromDt,
      toDt,
      filter,
      input,
      sort
    );
    let list = temp.data.map((item: any, index: number) => {
      return {
        ...item,
        updated_at: formatDateTime(item.updatedAt),
        no: item.id,
        key: item.id
      };
    });
    setList(list);
    setCurrentPage(page);
    setTotalPages(
      Number((temp.count / 10).toFixed(0)) +
        (temp.count % 10 !== 0 && temp.count > 10 ? 1 : 0)
    );
    setTotalItem(temp.count);
    setLoading(false);
  };

  useEffect(() => {
    getPagination(1, fromDt, toDt, proName, valueSearch, sort);
  }, [debounc, proName, sort, fromDt, toDt, valueSearch]);

  useEffect(() => {
    if (idExport.length > 0) {
      setSelectedRowKeys(idExport);
    }
  }, [currentPage, save]);

  return (
    <div>
      <BreadcrumbList listBreadcrumb={Breadcrumb} />
      <div className="admin-container">
        <Card
          bordered={false}
          className="admin-card"
          style={{
            minHeight: '80vh',
            background: 'none'
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          ></div>
          <div className="control">
            <RangePicker
              onChange={(date: any, dateString: [string, string]) => {
                getDate(dateString);
              }}
              placeholder={['YYYY.MM.DD', 'YYYY.MM.DD']}
              format={dateFormat}
            />
            {listLabel.map((item) => {
              return (
                <DropdownButton
                  key={item.id}
                  label={labelType.label}
                  menu={item.listMenu}
                />
              );
            })}
            <SearchBox
              type
              onChange={(e: any) =>
                onChangeState('Value Search', e.target.value)
              }
            />
          </div>
          <div className="table">
            <div>
              <div
                style={{
                  marginBottom: 16,
                  display: 'flex',
                  justifyContent: 'space-between',
                  paddingTop: 16
                }}
              >
                <div className="table__head">
                  <span style={{ marginLeft: 8 }}>
                    총 물류센터 &nbsp; {totalItem}
                  </span>
                  <span className="table__head --right">
                    선택 물류센터 &nbsp; {idExport.length}
                  </span>
                </div>

                <div>
                  <Button
                    className="downExcel"
                    onClick={() => {
                      handelExportExcel(
                        valueSearch,
                        proName,
                        sort,
                        fromDt,
                        toDt
                      );
                    }}
                  >
                    <span style={{ padding: '0 1rem', fontSize: '0.7rem' }}>
                      {t('common:download')}
                    </span>
                  </Button>
                </div>
              </div>
              <Table
                loading={loading}
                columns={columns}
                dataSource={list}
                rowSelection={rowSelection}
                pagination={{
                  total: totalItem,
                  current: currentPage,
                  showSizeChanger: false,
                  onChange: (page, limit) => {
                    getPagination(
                      page,
                      fromDt,
                      toDt,
                      proName,
                      valueSearch,
                      sort
                    );
                    setCurrentPage(page);
                  }
                }}
                // onRow={() => ()}
                onRow={(item) => {
                  return {
                    onClick: () => {
                      history.push(`/admin/busk/stock/${item.key}`);
                    }
                  };
                }}
              />
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default BuskStock;
